import postAPI from './postAPI.js'

export default async function postPreviewAction(payload) {
    const data = await postAPI('admin/taskflows/actions/preview', payload);
    return data;
}
